module.exports = __webpack_public_path__ + "static/media/6.550a0a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/carousel/6.png
// module id = 403
// module chunks = 0